module.exports = {
  'hy-am': {
    default: true,
    path: 'hy-am',
    // locale: 'Հայերեն',
    locale: 'ՀԱՅ',
  },
  'en-us': {
    path: 'en-us',
    // locale: 'English',
    locale: 'ENG',
  },
  // 'ru-ru': {
  //   path: 'ru-ru',
  //   // locale: 'Русский',
  //   locale: 'РУС',
  // },
};
